

/**
 * 热词卡片模块，已解耦
 * 用法：
 *  模版中 {% import 'hotwords/module/card/index.tpl' as card %} {{card.cardOne(lazy)}} lazy参数false为不使用懒加载
 *  脚本中 const Card = require('本模块路径')
 *  注意，默认使用懒加载的情况下，需要在业务页面额外引入懒加载模块
 *  @method createCardOne(Object) ... 系列函数赋予js创造卡片dom的能力,Object对象为卡片内容数据
 *  例： {"index":0,"cardType":5,"adAbstract":"一个即使输了也会点赞的游戏","userName":"叮当不会响","userAbstract":"网易前高级游戏总裁","userLevel":"one","userIcon":"https://image.9game.cn/2018/6/28/20738293_.png","gameId":123,"gameName":"游戏名","gameCategory":"分类","gameSize":"238M","gameScore":"8.0","gameAbstract":"一句话介绍","gameUrl":"#","gameIcon":"https://image.9game.cn/2018/6/28/20738293_.png","gameImgs":["https://image.9game.cn/2018/6/26/20717266.jpg","https://image.9game.cn/2018/6/26/20717265.jpg","https://image.9game.cn/2018/6/26/20717265.jpg"]}
 *  @method AppendCards(Array,callback) Array为卡片内容Object的数组,将生成整体dom结构，并作为回调参数返回给callback
 *
 */
// require('./index.scss');

// class Module {
//   constructor() {
//     // 公共
//     this.ShowMedia = require('public/show_media.js');
//     this.Init();
//   }
//   Init() {
//     this.BindCardEvent();
//   }

//   createGameItem(obj) {
//     const createScore = () => {
//       if (!obj.gameScore) return '';
//       return `<li>九游评分:<span class="detail-score">${obj.gameScore}</span></li>`;
//     };
//     return `<div class="game-item">
//     <div class="game-icon" type="btn" href="${obj.zoneHref}"><img class="lazy" data-statis="logo_hotword_gamelist_po_${obj.num}_${obj.gameId}" dataimg="${obj.gameIcon}" src="https://image.9game.cn/s/uae/g/1m/ngp_portal_mobile/page/homesite/index/images/lazy_d9f097f.gif"/></div>
//     <div class="game-info" type="btn" href="${obj.zoneHref}">
//       <p data-statis="txt_hotword_gamelist_po_${obj.num}_${obj.gameId}" class="info-title">${obj.gameName}</p>
//       <div class="info-detail">
//         <ul>
//           <li>${obj.gameCategory}</li>
//           <li>${obj.gameSize}</li>
//           ${createScore()}
//         </ul>
//       </div>
//       <div class="info-abstract">${obj.gameAbstract}</div>
//     </div>
//     <div data-game-id="${obj.gameId}" data-statis="btn_hotword_gamelist_po_${obj.num}_${obj.gameId}"  class="game-btn download game-recommend-download">下载</div>
//   </div>`;
//   }

//   createCardOne(obj) {
//     return `<div type="xlyx-count-item" data-game-id="${obj.gameId}" data-game-name="${obj.gameName}" class="card item-card-1">
//   <div class="card-1-bg"><img class="lazy" dataimg="${obj.gameImgs[0]}" src="https://image.9game.cn/s/uae/g/1m/ngp_portal_mobile/page/homesite/index/images/lazy_d9f097f.gif"></div>
//   <div class="card-1-play">
//     <div class="play" data-statis="logo_hotword_gamelist_video_po_${obj.num}_${obj.gameId}" data-play="${obj.videoPlay}"></div>
//   </div>
//     ${this.createGameItem(obj)}
//   </div>
// </div>`;
//   }

//   createCardTwo(obj) {
//     const arrImg = obj.gameImgs.map(e => {
//       return `<li><img data-statis="logo_hotword_gamelist_pic_po_${obj.num}_${obj.gameId}" class="lazy show" dataimg="${e}" src="https://image.9game.cn/s/uae/g/1m/ngp_portal_mobile/page/homesite/index/images/lazy_d9f097f.gif"/></li>`;
//     });
//     return `<div type="xlyx-count-item" data-game-id="${obj.gameId}" data-game-name="${obj.gameName}" class="card item-card-2">
//   <div class="card-2-banner">
//       <ul class="banner-scroll">
//         ${arrImg.join('')}
//       </ul>
//   </div>
//    ${this.createGameItem(obj)}
// </div>`;
//   }

//   createCardThree(obj) {
//     const arrImg = obj.gameImgs.map(e => {
//       return `<li><img class="lazy show" data-statis="logo_hotword_gamelist_pic_po_${obj.num}_${obj.gameId}" dataimg="${e}" src="https://image.9game.cn/s/uae/g/1m/ngp_portal_mobile/page/homesite/index/images/lazy_d9f097f.gif"/></li>`;
//     });
//     return `<div type="xlyx-count-item" data-game-id="${obj.gameId}" data-game-name="${obj.gameName}" class="card item-card-3">
//   <div class="card-3-banner">
//       <ul class="banner-scroll">
//         ${arrImg.join('')}
//       </ul>
//   </div>
//   ${this.createGameItem(obj)}
// </div>`;
//   }

//   createCardFour(obj) {
//     return `<div type="xlyx-count-item" data-game-id="${obj.gameId}" data-game-name="${obj.gameName}" class="card item-card-4">
//   <div class="card-4-bg"><img class="lazy" dataimg="${obj.gameImgs[ 0 ]}" src="https://image.9game.cn/s/uae/g/1m/ngp_portal_mobile/page/homesite/index/images/lazy_d9f097f.gif"></div>
//   <div class="card-4-play show" data-statis="logo_hotword_gamelist_pic_po_${obj.num}_${obj.gameId}"></div>
//   ${this.createGameItem(obj)}
// </div>`;
//   }

//   createCardFive(obj) {
//     return `<div type="xlyx-count-item" data-game-id="${obj.gameId}" data-game-name="${obj.gameName}" class="card item-card-5">
//   <div class="card-5-userinfo">
//     <div class="userinfo-headicon">
//       <img class="lazy"  dataimg="${obj.userIcon}" src="https://image.9game.cn/s/uae/g/1m/ngp_portal_mobile/page/homesite/index/images/lazy_d9f097f.gif"/>
//     </div>
//     <div class="userinfo-info">
//       <div class="info-name">${obj.userName}</div>
//       <div class="info-level">
//         <div class="level-icon ${obj.userLevel}"></div>
//         <div class="level-abstract">${obj.userAbstract}</div>
//       </div>
//     </div>
//   </div>
//   <div class="card-5-detail">${obj.adAbstract}</div>
//   ${this.createGameItem(obj)}
// </div>`;
//   }

//   createCardSix(obj) {
//     return `<div type="xlyx-count-item" data-game-id="${obj.gameId}" data-game-name="${obj.gameName}" class="card item-card-6">
//     ${this.createGameItem(obj)}
// </div>`;
//   }

//   AppendCards(arr, callback) {
//     const result = arr.map((v, index) => {
//       switch (v.cardType) {
//         case 1:
//           return this.createCardOne(v);
//         case 2:
//           return this.createCardTwo(v);
//         case 3:
//           return this.createCardThree(v);
//         case 4:
//           return this.createCardFour(v);
//         case 5:
//           return this.createCardFive(v);
//         case 6:
//           return this.createCardSix(v);
//         default:
//           return '';
//       }
//     });
//     callback ? callback(result.join('')) : '';
//     this.BindCardEvent();
//   }

//   BindCardEvent() {
//     $('.main-game-theme').find('img.show').on('click', (e) => {
//       this.ShowMedia.ToggleCover('img', $(e.target).attr('src'));
//     });
//     $('.main-game-theme').find('img.show').on('click', (e) => {
//       this.ShowMedia.ToggleCover('img', $(e.target).attr('src'));
//     });
//     $('.main-game-theme').find('.card-4-play').on('click', (e) => {
//       this.ShowMedia.ToggleCover('img', $('.card-4-bg').find('img').attr('src'));
//     });
//     $('.card-1-play').find('.play').on('click', (e) => {
//       const Item = $(e.target).parents('.card').find('.game-item').clone();
//       const gameItem = $('<div class="m-show-media-gameitem-container"></div>').append(Item);
//       this.ShowMedia.ToggleCover('video', $(e.target).data('play'), function(e) {
//         e.find('.m-show-media-cover-video').after(gameItem);
//       });
//     });
//   }
// }

class Module {
  constructor() {
    // 公共
    this.ShowMedia = require('public/show_media.js');
    this.isbd = parseInt($('#_isbd').val(), 10);
    this.Init();
  }
  Init() {
    this.BindCardEvent();
  }

  createCardImgs(obj) {
    if (obj.cardType === 'single') {
      return `<img class="img show lazy" dataimg="${obj.gameImgs[0]}" src="https://image.9game.cn/s/uae/g/0h/portal/image/lazy2.gif" alt="${obj.gameName}截图">`;
    } else if (obj.cardType === 'horizontal' || obj.cardType === 'vertical') {
      const arrImg = obj.gameImgs.map((e, idx) => {
        return `<li class="item"><img class="lazy img show" dataimg="${e}" src="https://image.9game.cn/s/uae/g/0h/portal/image/lazy2.gif" alt="${obj.gameName}截图${idx}"></li>`;
      });
      return `<ul class="game-imgs">${arrImg.join('')}</ul>`;
    }
  }

  createCardIntro(obj) {
    if (obj.gameKeywords.length > 0) {
      const arrKeys = obj.gameKeywords.map((e, idx) => {
        if (obj.gameKeywordsUrl.length > 0 && obj.gameKeywordsUrl[idx]) {
          return `<a href="${obj.gameKeywordsUrl[idx]}" title="${e}" class="tag">${e}</a>`;
        } else {
          return `<span class="tag">${e}</span>`;
        }
      }).slice(0, 3);
      return `<div class="game-tags">${arrKeys.join('')}</div>`;
    } else {
      const createCategory = () => {
        if (obj.gameCategoryUrl) {
          return `<a href="${obj.gameCategoryUrl}" title="${obj.gameCategory}">${obj.gameCategory}</a>`;
        } else {
          return `<span title="${obj.gameCategory}">${obj.gameCategory}</span>`;
        }
      };
      if (obj.gameSize) {
        return `<div class="game-intro">
       ${createCategory()}&nbsp;|&nbsp;${obj.gameSize}
      </div>`;
      } else {
        return `<div class="game-intro">${createCategory()}</div>`;
      }
    }
  }

  createCard(obj) {
    const sidEndChar = '' + $('#sidEndChar').val();
    const createScore = () => {
      let score = '5.2';
      if (obj.gameScore !== '') {
        score = obj.gameScore;
      }
      return `<div class="game-score">${score}</div>`;
    };
    const createDesc = () => {
      if (obj.gameDesc) {
        return `<div class="game-desc limit">
        ${obj.gameDesc}
        <a href="${obj.zoneHref}" class="more">全部</a>
      </div>`;
      } else {
        return '';
      }
    };
    const createDown = () => {
      if (this.isbd === 1) {
        if (obj.gameUrl.indexOf('game/downs_') > -1) {
          return `<div class="game-down game-btn download JS_bd_down" data-more="1" data-url="${obj.gameUrl}" data-game-id="${obj.gameId}" data-ishigh="1">高速下载</div>
          <div class="download-select JS_bd_toggle" data-more="1">
            <div class="select-btn select"></div>
            <div class="text">用九游App下载</div>
          </div>`;
        } else {
          return `<div class="game-down game-btn download JS_ng_down" data-more="1" data-game-id="${obj.gameId}">预约</div><div class="game-tips">使用九游APP预约</div>`;
        }
      } else {
        return `<div class="game-down game-btn download game-recommend-download JS_ng_down" data-more="1" data-game-id="${obj.gameId}">下载</div><div class="game-tips">${obj.gameAbstract}</div>`;
      }
    };
    return `<div class="main-game-item two ${obj.cardType}" type="xlyx-count-item" data-game-id="${obj.gameId}" data-game-name="${obj.gameName}">
        <div class="game-imgs-box">
          ${this.createCardImgs(obj)}
        </div>
        <div class="game-main">
          <div class="game-basic">
            <a href="${obj.zoneHref}" class="game-icon">
              <img class="img lazy" dataimg="${obj.gameIcon}" src="https://image.9game.cn/s/uae/g/0n/static/ngm-portal/public/img/lazy2.9b2f125e.gif" alt="${obj.gameName}">
            </a>
            <div class="game-info">
              <a class="game-tit" href="${obj.zoneHref}" title="${obj.gameName}">
                ${obj.gameName}
              </a>
              ${this.createCardIntro(obj)}
            </div>
          </div>
          ${createScore()}
        </div>
        ${createDesc()}
        ${createDown()}
      </div>`;
    // if ('c,d,e,f'.indexOf(sidEndChar) > -1) {
    //   return `<div class="main-game-item two ${obj.cardType}" type="xlyx-count-item" data-game-id="${obj.gameId}" data-game-name="${obj.gameName}">
    //     <div class="game-imgs-box">
    //       ${this.createCardImgs(obj)}
    //     </div>
    //     <div class="game-main">
    //       <div class="game-basic">
    //         <a href="${obj.zoneHref}" class="game-icon">
    //           <img class="img lazy" dataimg="${obj.gameIcon}" src="https://image.9game.cn/s/uae/g/0n/static/ngm-portal/public/img/lazy2.9b2f125e.gif" alt="${obj.gameName}">
    //         </a>
    //         <div class="game-info">
    //           <a class="game-tit" href="${obj.zoneHref}" title="${obj.gameName}">
    //             ${obj.gameName}
    //           </a>
    //           ${this.createCardIntro(obj)}
    //         </div>
    //       </div>
    //       ${createScore()}
    //     </div>
    //     ${createDesc()}
    //     ${createDown()}
    //   </div>`;
    // } else if ('0,1,2,3,4,5'.indexOf(sidEndChar) > -1) {
    //   const createDown = (obj) => {
    //     if (parseInt(obj.haspack, 10) === 1) {
    //       const btnCtn = () => {
    //         if (obj.giftlen > 0) {
    //           return `<span class="txt" data-ntxt="普通下载" data-htxt="下载抢好礼">下载抢好礼</span>
    //           <div class="v21_gift JS_ani"></div>`;
    //         } else {
    //           return `<span class="txt" data-ntxt="普通下载" data-htxt="极速下载">极速下载</span>
    //           <div class="acc_box JS_ani">
    //             <div class="v21_acc"></div>
    //           </div>`;
    //         }
    //       };
    //       const tipCtn = () => {
    //         if (obj.giftlen > 0) {
    //           return `<div class="text select">
    //           使用九游APP下载，游戏礼包等你领取
    //           <div class="tips">
    //             <div class="v21_gift"></div>
    //           </div>
    //         </div>`;
    //         } else {
    //           return `<div class="text select">
    //           使用九游APP下载，下载速度立提80%
    //           <div class="tips">
    //             <div class="acc_box">
    //               <div class="v21_acc"></div>
    //             </div>
    //           </div>
    //         </div>`;
    //         }
    //       };
    //       return `<div class="game-down JS_v21_down" data-game-id="${obj.gameId}" data-url="${obj.gameUrl}" data-more="1" data-ishigh="1">
    //         ${btnCtn()}
    //       </div>
    //       <div class="download-select JS_v21_toggle" data-more="1">
    //         <div class="select-btn select"></div>
    //         ${tipCtn()}
    //       </div>`;
    //     } else if (parseInt(obj.haspack, 10) === 0) {
    //       const iconType = () => {
    //         if (obj.giftlen > 0) {
    //           return '<div class="v21_gift"></div>';
    //         } else {
    //           return '<div class="v21_star"></div>';
    //         }
    //       };
    //       return `<div class="game-down JS_v21_down" data-more="1" data-ishigh="1" data-game-id="${obj.gameId}">
    //       <span class="txt">立即预约</span>
    //       ${iconType()}
    //     </div>
    //     <div class="game-tips">下载九游APP，获取新游最新信息&礼包</div>`;
    //     }
    //   };
    //   return `<div class="v21_mgameitem ${obj.cardType}" type="xlyx-count-item" data-game-id="${obj.gameId}" data-game-name="${obj.gameName}">
    //     <div class="game-imgs-box">
    //       ${this.createCardImgs(obj)}
    //     </div>
    //     <div class="game-main">
    //       <div class="game-basic">
    //         <a href="${obj.zoneHref}" class="game-icon">
    //           <img class="img lazy" dataimg="${obj.gameIcon}" src="https://image.9game.cn/s/uae/g/0n/static/ngm-portal/public/img/lazy2.9b2f125e.gif" alt="${obj.gameName}">
    //         </a>
    //         <div class="game-info">
    //           <a class="game-tit" href="${obj.zoneHref}" title="${obj.gameName}">
    //             ${obj.gameName}
    //           </a>
    //           ${this.createCardIntro(obj)}
    //           <div class="game-opstatus">${obj.operationstatus}</div>
    //         </div>
    //       </div>
    //       ${createScore()}
    //     </div>
    //     ${createDesc()}
    //     ${createDown(obj)}
    //   </div>`;
    // } else if ('6,7,8,9,a,b'.indexOf(sidEndChar) > -1) {
    //   const createCate = () => {
    //     if (obj.gameSize) {
    //       return `<div class="game-types">
    //       ${obj.gameCategory}&nbsp;|&nbsp;${obj.gameSize}
    //     </div>`;
    //     } else {
    //       return `<div class="game-types">
    //       ${obj.gameCategory}
    //     </div>`;
    //     }
    //   };
    //   const createKey = () => {
    //     if (obj.gameKeywords && obj.gameKeywords.length > 0) {
    //       const arrKeys = obj.gameKeywords.map(e => {
    //         return `<span class="tag">${e}</span>`;
    //       }).slice(0, 2);
    //       return `<div class="game-tags">${arrKeys.join('')}</div>`;
    //     } else {
    //       return createCate();
    //     }
    //   };
    //   const createInfos = () => {
    //     if (obj.giftlen > 0) {
    //       return `${createCate()}
    //       <div class="game-gifts o">
    //         <i class="icon-gift"></i>
    //         <span class="txt">还有${obj.giftlen}个礼包</span>
    //       </div>`;
    //     } else {
    //       return `${createKey()}
    //       <div class="game-opstatus">${obj.operationstatus}</div>`;
    //     }
    //   };
    //   const cdown = () => {
    //     if (parseInt(obj.haspack, 10) === 1) {
    //       if (obj.giftlen > 0) {
    //         return `<div class="game-down JS_v22_down" data-ntxt="普通下载" data-htxt="下载有礼" data-url="${obj.gameUrl}" data-game-id="${obj.gameId}" data-more="1" data-ishigh="1">
    //           下载有礼
    //         </div>
    //         <div class="download-select JS_v22_toggle" data-more="1">
    //           <div class="select-btn select"></div>
    //           <div class="text" data-ntxt="勾选领好礼" data-htxt="下九游领取">下九游领取</div>
    //         </div>`;
    //       } else {
    //         return `<div class="game-down JS_v22_down"  data-url="${obj.gameUrl}"data-ntxt="普通下载" data-htxt="极速下载" data-game-id="${obj.gameId}" data-more="1" data-ishigh="1">
    //           极速下载
    //         </div>
    //         <div class="download-select JS_v22_toggle" data-more="1">
    //           <div class="select-btn select"></div>
    //           <div class="text" data-ntxt="勾选享提速" data-htxt="享80%提速">享80%提速</div>
    //         </div>`;
    //       }
    //     } else if (parseInt(obj.haspack, 10) === 0) {
    //       if (obj.giftlen > 0) {
    //         return `<div class="game-down JS_v22_down" data-game-id="${obj.gameId}" data-more="1" data-ishigh="1">
    //           预约有礼
    //         </div>
    //         <div class="game-tips">下九游领取</div>`;
    //       } else {
    //         return `<div class="game-down JS_v22_down" data-game-id="${obj.gameId}" data-more="1" data-ishigh="1">
    //           预约游戏
    //         </div>
    //         <div class="game-tips">需下载九游</div>`;
    //       }
    //     }
    //   };
    //   return `<div class="v22_mgameitem ${obj.cardType}" type="xlyx-count-item" data-game-id="${obj.gameId}" data-game-name="${obj.gameName}">
    //   <div class="game-main">
    //     <div class="game-basic">
    //       <a href="${obj.zoneHref}" class="game-icon">
    //         <img class="img lazy" dataimg="${obj.gameIcon}" src="https://image.9game.cn/s/uae/g/0n/static/ngm-portal/public/img/lazy2.9b2f125e.gif" alt="${obj.gameName}">
    //       </a>
    //       <div class="game-info">
    //         <a class="game-tit" href="${obj.zoneHref}" title="${obj.gameName}">
    //           ${obj.gameName}
    //         </a>
    //         ${createInfos()}
    //       </div>
    //     </div>
    //     <div class="game-downs">
    //       ${cdown()}
    //     </div>
    //   </div>
    //   ${createDesc()}
    //   <div class="game-imgs-box">
    //     ${this.createCardImgs(obj)}
    //   </div>
    // </div>`;
    // }
  }

  AppendCards(arr, callback) {
    const result = arr.map((v, index) => {
      return this.createCard(v);
    });
    callback ? callback(result.join('')) : '';
    this.BindCardEvent();
  }

  BindCardEvent() {
    $('.main-game-theme').find('img.show').off('click', (e) => {
      this.ShowMedia.ToggleCover('img', $(e.target).attr('src'));
    });
    $('.main-game-theme').find('img.show').on('click', (e) => {
      this.ShowMedia.ToggleCover('img', $(e.target).attr('src'));
    });
  }
}

module.exports = new Module();


// WEBPACK FOOTER //
// ./jws/views/page/hotwords/module/card/index.js